import moment from 'moment';
import zeroPad from './zeroPad';

export const parseTime = val => {
  const regexStandard = RegExp('[0-2]?[0-9]:[0-5]?[0-9]');
  const regexNoDash = RegExp('[0-2][0-9][0-5][0-9]');
  const regexHourOnly = RegExp('([0-2]?[0-9])');

  const regexStringDot = '[0-2]?[0-9]\\.[0-5]?[0-9]';
  const regexStringSemicolon = '[0-2]?[0-9];[0-5]?[0-9]';
  const regexStringComma = '[0-2]?[0-9],[0-5]?[0-9]';

  const regexDot = RegExp(regexStringDot);
  const regexSemicolon = RegExp(regexStringSemicolon);
  // const regexComma = RegExp(regexStringComma);
  const regexTrio = RegExp(
    `${regexStringDot}|${regexStringSemicolon}|${regexStringComma}`,
  );

  if (val.match(regexStandard)) {
    // format is perfectly fine
    let numbers = val.split(':');
    return zeroPad(numbers[0], 2) + ':' + zeroPad(numbers[1], 2);
  } else if (val.match(regexNoDash)) {
    return val.slice(0, 2) + ':' + val.slice(2, 4);
  } else if (val.match(regexTrio)) {
    const splitter = val.match(regexDot)
      ? '.'
      : val.match(regexSemicolon)
      ? ';'
      : ',';
    const numbers = val.split(splitter);

    return zeroPad(numbers[0], 2) + ':' + zeroPad(numbers[1], 2);
  } else if (val.match(regexHourOnly)) {
    return zeroPad(val.match(regexHourOnly)[0], 2) + ':00';
  } else {
    return moment().format('HH:mm');
  }
};

export default parseTime;



// WEBPACK FOOTER //
// ./src/helpers/parseTime.js